import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import GenericBundleFeatureTable from '../feature-table/suite-feature-table/GenericBundleFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileBundleFeatureTable = ({
  apiNames,
  productLevel,
  productLinesFromBundle,
  screen,
  trackingSource
}) => {
  const [showFeatureTable, setShowFeatureTable] = useState(false);
  const toggleShowFeatureTable = evt => {
    evt.preventDefault();
    setShowFeatureTable(prev => !prev);
  };
  const filteredHighlightedProducts = apiNames.filter(apiName => {
    return getProductLevelFromApiNameString(apiName) === productLevel;
  });
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "100",
    children: [/*#__PURE__*/_jsx(Button, {
      use: "transparent",
      onClick: toggleShowFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: showFeatureTable ? 'suiteFeatureTable.mobile.hideAll' : 'suiteFeatureTable.mobile.seeAll'
      })
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      duration: 500,
      renderContent: () => /*#__PURE__*/_jsx(GenericBundleFeatureTable, {
        apiNames: filteredHighlightedProducts,
        productLinesFromBundle: productLinesFromBundle
        // Resets expanded state of table content
        ,

        screen: screen,
        trackingSource: trackingSource
      }, productLevel),
      open: showFeatureTable
    })]
  });
};
export default MobileBundleFeatureTable;